import debounce from 'lodash/debounce'

const updateBackgroundImage = (element) => {
    let desktopSrc = element.getAttribute('data-srcDesktop');
    let tabletSrc = element.getAttribute('data-srcTablet');
    let mobileSrc = element.getAttribute('data-srcMobile');

    var screenwidth = window.innerWidth;

    //check if lazy loading
    //change the data-src tag
    var classList = element.classList;
    if (classList.contains("lazy-bg-force") && !classList.contains("lazy-bg-loaded")) {
        if (screenwidth <= 425 && mobileSrc !== "") {
            element.setAttribute("data-src", mobileSrc);
        }
        else if (screenwidth <= 768 && tabletSrc !== "") {
            element.setAttribute("data-src", tabletSrc);
        }
        else {
            element.setAttribute("data-src", desktopSrc);
        }
    } else {
        if (screenwidth <= 425 && mobileSrc !== "") {
            element.style.backgroundImage = `url("${mobileSrc}")`;
        }
        else if (screenwidth <= 768 && tabletSrc !== "") {
            element.style.backgroundImage = `url("${tabletSrc}")`;
        }
        else {
            element.style.backgroundImage = `url("${desktopSrc}")`;
        }
    }
   
}

const updateAllBackgroundImages = () => {
    document.querySelectorAll('.bg-img-responsive').forEach((element) => {
        updateBackgroundImage(element)
    })
}

window.addEventListener('DOMContentLoaded', () => {
    updateAllBackgroundImages();
});

window.addEventListener('orientationchange', debounce(updateAllBackgroundImages, 300));